/*
 * Copyright (c) 2023. Word Wide Generation Ltd
 */

export enum SetupTaskType {
  /** Essentially hardcoded task in the codebase **/
  Static = 'static'
}

export enum SetupTaskGroup {
  CustomMetrics = 'custom-metric-groups',
  Survey = 'survey',
  Initiative = 'initiative',
  User = 'user',
}

export enum SetupTaskStatus {
  Draft = 'draft',
  Active = 'active',
  Disabled = 'disabled',
}

export enum SetupTaskAction {
  Complete = 'complete',
  Delete = 'deleted',
}

/**
 * Intermediate actions for user interaction
 **/
export enum SetupTaskUserAction {
  ConfirmDelete = 'confirm_deleted',
}

export interface SetupTaskRequest {
  taskId: string,
  action: SetupTaskAction
  initiativeId?: string;
}


export interface SetupTask {

  _id: string

  /** Unique code for the task, should be used as reference if possible **/
  code: string;

  name: string;

  description?: string;

  /** for flexibility this will allow to create different kind of tasks **/
  type: SetupTaskType.Static


  status: SetupTaskStatus;

  /**
   * Represent a group code that groups number of tasks
   * Can target CT, CT Pro, PT or assurance etc.
   */
  groups: SetupTaskGroup[];

  /** Priority of the task within the group **/
  sortOrder: number;

  /** OnClick url to go to **/
  url?: string;
}


interface SetupTaskActionPlain {
  taskId: string,
  userId: string,
  initiativeId?: string,
  deletedDate?: string,
  completedDate?: string,
}

export type TaskWithAction = SetupTask & { action?: SetupTaskActionPlain }
